import React from 'react'
import PropTypes from 'prop-types'
import { getUserDetails } from 'utils/hooks/useUserDetails'

// set an upper bound (25 minutes) on a single viewing of a shipment
// in case somebody leaves a window open
const MAX_EVENTS = 50

export class ShipmentTrackerComponent extends React.Component {
  constructor() {
    super()
    const shipmentCheck = setInterval(() => {
      this.emit()
    }, 30000)
    this.state = { countedEvents: 0, shipmentCheck }
  }

  componentDidMount() {
    this.emit()
  }

  componentWillUnmount() {
    const { shipmentCheck } = this.state
    clearInterval(shipmentCheck)
  }

  emit() {
    const { shipment } = this.props
    const { countedEvents } = this.state
    const { id: userId, userType } = getUserDetails() || {}

    if (
      document.visibilityState === 'visible' &&
      this.props &&
      shipment &&
      shipment.id &&
      countedEvents < MAX_EVENTS
    ) {
      const params = {
        userId,
        userType,
        context: 'Booking page sidebar',
        shipmentId: shipment.id,
        status: shipment.status.name,
      }
      this.setState(prevState => ({ countedEvents: prevState.countedEvents + 1 }))
    }
  }

  render() {
    return null
  }
}

ShipmentTrackerComponent.propTypes = {
  shipment: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
}
